import axios from 'axios';
import { PS_API_URL } from '.';
import { ICoin } from '../reducers/dex/tradingReducer';

/**
 * Call to paraswap
 * @returns
 */
const getPriceRequest = async ({
  base,
  quote,
  network,
  onNotify,
  controller,
}: {
  base: ICoin;
  quote: ICoin;
  network: string;
  onNotify?: any;
  controller: AbortController;
}) => {
  const queryParams = {
    srcToken: base.address,
    destToken: quote.address,
    srcDecimals: base.decimals.toString(),
    destDecimals: quote.decimals.toString(),
    amount: base.amount.times(10 ** base.decimals).toFixed(),
    network,
    side: 'SELL',
    partner: 'kattana',
    partnerAddress: '0x3E2fa2A037444D76A99eaE6654Cd4EAB049bb5f7',
    partnerFeeBps: '20',
  };

  const searchString = new URLSearchParams(queryParams);
  const pricesURL = `${PS_API_URL}/prices/?${searchString}`;

  try {
    const { data } = await axios.get(pricesURL, {
      signal: controller.signal,
    });

    return {
      data: data,
      error: null,
    };
  } catch (err: any) {
    if (controller.signal.aborted) {
      return {
        data: null,
        error: err,
      };
    }
    if (err.response?.data) {
      const { error, value } = err.response.data;
      if (error === 'ESTIMATED_LOSS_GREATER_THAN_MAX_IMPACT') {
        onNotify?.({
          kind: 'warning',
          message: `Estimated loss greater than max impact: ${value}`,
        });
      } else {
        onNotify?.({ kind: 'warning', message: `${error} ${value}` });
      }
    }
    console.warn('[getPriceRequest]', err);
    return {
      data: null,
      error: err,
    };
  }
};

export { getPriceRequest };
